import apiClient from "./axios";

/**
 * Dashboard API
 * 遵循 API_GUIDELINES.md 规范
 *
 * 注意: 所有函数返回 response.data 以与项目其他API模块保持一致
 */
export const dashboardApi = {
    /**
     * 获取当前用户的 Dashboard 布局
     * @returns {Promise<Object>} 布局数据 { layout: Array, source: string }
     */
    getLayout: async () => {
        const response = await apiClient.get("/v1/dashboard/layout");
        return response.data;
    },

    /**
     * 保存当前用户的 Dashboard 布局
     * @param {Array} layout 布局数据
     * @returns {Promise<Object>} 操作结果 { success: boolean, message: string }
     */
    updateLayout: async (layout) => {
        const response = await apiClient.post("/v1/dashboard/layout", { layout });
        return response.data;
    },

    /**
     * 重置当前用户的 Dashboard 布局
     * @returns {Promise<Object>} 操作结果 { success: boolean, message: string }
     */
    resetLayout: async () => {
        const response = await apiClient.delete("/v1/dashboard/layout");
        return response.data;
    },

    /**
     * 获取所有 Dashboard 模版
     * @returns {Promise<Array>} 模版列表
     */
    getTemplates: async () => {
        const response = await apiClient.get("/v1/dashboard/templates");
        return response.data;
    },

    /**
     * 获取单个 Dashboard 模版
     * @param {number} id 模版ID
     * @returns {Promise<Object>} 模版详情
     */
    getTemplate: async (id) => {
        const response = await apiClient.get(`/v1/dashboard/templates/${id}`);
        return response.data;
    },

    /**
     * 创建 Dashboard 模版
     * @param {Object} data 模版数据
     * @returns {Promise<Object>} 操作结果 { success: boolean, message: string, data: Object }
     */
    createTemplate: async (data) => {
        const response = await apiClient.post("/v1/dashboard/templates", data);
        return response.data;
    },

    /**
     * 更新 Dashboard 模版
     * @param {number} id 模版ID
     * @param {Object} data 更新数据
     * @returns {Promise<Object>} 操作结果 { success: boolean, message: string, data: Object }
     */
    updateTemplate: async (id, data) => {
        const response = await apiClient.put(`/v1/dashboard/templates/${id}`, data);
        return response.data;
    },

    /**
     * 删除 Dashboard 模版
     * @param {number} id 模版ID
     * @returns {Promise<Object>} 操作结果 { success: boolean, message: string }
     */
    deleteTemplate: async (id) => {
        const response = await apiClient.delete(`/v1/dashboard/templates/${id}`);
        return response.data;
    },
};

export default dashboardApi;
